import PlatformActions from './PlatformActions'

export default class JILIFISHActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'FH',
      gameName: 'Jackpot Fishing',
      gameCode: 'JILI-FISH-003',
      platform: 'JILI',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 562185538329649184
      roundId: txnId, // 562185538329649184
      betType: null,
      currency,
      betTime, // 2021-10-01T14:09:37.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: 0,
      updateTime, // 2021-10-01T14:09:37.230+08:00
      requireAmount: betAmount,
      gameInfo: {
        isEndRound: true,
        isBuyFreeSpin: false,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId: txnId,
      updateTime,
      betAmount,
      gameInfo: {
        isEndRound: true,
        isBuyFreeSpin: false,
      },
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
